<template>
  <img
      class="flex pr-32.5"
      :src="require('@/assets/images/blog/' + source )"
      alt=""
  />
</template>

<script>
export default {
  name: "imageElement",
  props:['source']
}
</script>

<style scoped>

</style>